export enum CourseDataTypeEnum {
  Unit = 'unit',
  Objectives = 'objectives',
  Outcome = 'outcome',
  Resources = 'resources',
  Textbooks = 'textbooks',
  Weblinks = 'weblinks',
  Topic = 'topic',
  Code ='code',
  Course_Title = 'title',
  Course_duration = 'duration',
  Course_Unit_Count = 'count'
}